/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Stats_RolesInputs */

const en_admin_stats_roles = /** @type {(inputs: Admin_Stats_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

const zh_admin_stats_roles = /** @type {(inputs: Admin_Stats_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色数`)
};

/**
* | output |
* | --- |
* | "Roles" |
*
* @param {Admin_Stats_RolesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_stats_roles = /** @type {((inputs?: Admin_Stats_RolesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Stats_RolesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_stats_roles(inputs)
	return zh_admin_stats_roles(inputs)
});
export { admin_stats_roles as "admin.stats.roles" }